import React, { Component } from "react";
import classNames from "classnames";
import { AppContext } from "~/scripts/context/app";
import { isMobile } from "~/scripts/utils/is-mobile";

class Background extends Component {
    static contextType = AppContext;

    componentDidMount() {
        if (isMobile) {
            document.body.classList.add("is-mobile");
        }
    }

    render() {
        const { theme } = this.context;

        return <div className={classNames("background", `theme-${theme}`)} />;
    }
}

export default Background;



// WEBPACK FOOTER //
// ./src/scripts/components/Background.js